import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/browser';

export const setBrowserName = createAction(types.SET_BROWSER_NAME);
export const setOSName = createAction(types.SET_OS_NAME);
export const updateModifierKeyPressedStatus = createAction(types.UPDATE_MODIFIER_KEY_PRESSED_STATUS);
export const updateLeftPanelCollapsedStatus = createAction(types.UPDATE_LEFT_PANEL_COLLAPSED_STATUS);
export const setApplicationFocus = createAction(types.SET_APPLICATION_FOCUS);
export const appModeChanged = createAction(types.APP_MODE_CHANGED);
